/**
 * 📄 Class that represents the current OBT holding tier of the user
 */
export default class OBTHoldingTier {
  constructor(
    public tier: string,
    public discount: number,
    public requiredOBT: number,
    public allowedBots: number,
    public maxTotalInUse: number
  ) { }

  public getTierName(): string {
    switch (this.tier) {
      case "init": return "Base";
      case "1": return "Tier 1";
      case "2": return "Tier 2";
      case "3": return "Tier 3";
      case "4": return "Tier 4";
      case "5": return "Tier 5";
      case "6": return "Tier 6";
      case "7": return "Tier 7";
      case "8": return "Tier 8";
      default: return this.tier
    }
  }
}